/**
 * EmailFieldType — email z walidacją @. Storage: PG TEXT.
 */

import type { FieldInputProps, FieldTypeDefinition } from '../FieldRegistry';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function EmailInput({ field, value, onChange, error, disabled, autoFocus }: FieldInputProps) {
  return (
    <input
      type="email"
      value={typeof value === 'string' ? value : ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      autoFocus={autoFocus}
      placeholder="np. jan@firma.pl"
      aria-invalid={!!error}
      data-testid={`field-${field.slug}-input`}
      className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-2 text-sm text-text-primary placeholder-text-muted focus:border-accent-500 focus:outline-none focus:ring-1 focus:ring-accent-500 disabled:opacity-50"
    />
  );
}

export const EmailFieldType: FieldTypeDefinition = {
  type: 'email',
  renderInput: (props) => <EmailInput {...props} />,
  renderCell: (_field, value) => (typeof value === 'string' ? value : ''),
  validate: (value) => {
    if (typeof value !== 'string' || value.trim() === '') return null;
    if (!EMAIL_REGEX.test(value)) return 'invalid_email';
    return null;
  },
  defaultValue: '',
};
